import { EnvironmentType } from "../../../../modules/environment/envTypes"

const ITEM_HEIGHT = 48
const ITEM_PADDING_TOP = 8

export const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
}

// Filters whose backend endpoint is not live yet: shown only where a 404 falls back to the Postman mock.
export const UNFINISHED_FILTER_ENVIRONMENTS = [EnvironmentType.Local, EnvironmentType.Test]
